import { useContext } from "react";
import { SearchFormContext } from "./SearchFormContext";
import { DataFormContext } from "../../DataForm/src/DataFormContext";

export function useSearchFormInstance () {
  const { formRef } = useContext(DataFormContext);
  const context = useContext(SearchFormContext);

  return {
    ...formRef,
    ...context
  };
}
